const teamDefaultState = {
  currentAccount: {},
}

export default teamDefaultState
